import { render, staticRenderFns } from "./UserSocialList.vue?vue&type=template&id=2480fd10&"
import script from "./UserSocialList.vue?vue&type=script&lang=js&"
export * from "./UserSocialList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports